import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterBuilderViewSheet from './CharacterBuilderViewSheet.vue';
import CharacterBuilderSpecies from './CharacterBuilderSpecies.vue';
import CharacterBuilderClasses from './CharacterBuilderClasses.vue';
import CharacterBuilderAbilityScores from './CharacterBuilderAbilityScores.vue';
import CharacterBuilderDescription from './CharacterBuilderDescription.vue';
import CharacterBuilderEquipment from './CharacterBuilderEquipment.vue';
import { every } from 'lodash';
import CharacterBuilderSettings from './CharacterBuilderSettings.vue';
let CharacterBuilder = class CharacterBuilder extends Vue {
    get steps() {
        return [{},
            {
                name: 'Species',
                component: 'CharacterBuilderSpecies',
                props: {
                    species: this.species,
                    currentSpecies: this.character.species
                },
                isComplete: this.character.species.name !== ''
            },
            {
                name: 'Class',
                component: 'CharacterBuilderClasses',
                props: {
                    character: this.character,
                    classes: this.classes,
                    features: this.features
                },
                isComplete: this.character.classes.length > 0
            },
            {
                name: 'Ability Scores',
                component: 'CharacterBuilderAbilityScores',
                props: {
                    abilityScoreMethod: this.character.settings.abilityScoreMethod,
                    currentScores: this.character.baseAbilityScores
                },
                isComplete: every(this.character.baseAbilityScores, score => score > 0)
            },
            {
                name: 'Description',
                component: 'CharacterBuilderDescription',
                props: {
                    currentBackground: this.character.background,
                    backgrounds: this.backgrounds,
                    name: this.character.name,
                    image: this.character.image,
                    characteristics: this.character.characteristics
                },
                isComplete: this.character.name !== '' &&
                    this.character.background.name !== ''
            },
            {
                name: 'Equipment',
                component: 'CharacterBuilderEquipment',
                props: {
                    rawCharacter: this.character
                },
                isComplete: this.character.equipment.length > 0
            }
        ];
    }
    get numSteps() {
        return this.steps.length - 1;
    }
    nextStep() {
        this.$emit('goToStep', Math.min(this.numSteps, this.currentStep + 1));
    }
    prevStep() {
        this.$emit('goToStep', Math.max(this.currentStep - 1, 0));
    }
};
__decorate([
    Prop(Object)
], CharacterBuilder.prototype, "character", void 0);
__decorate([
    Prop(Object)
], CharacterBuilder.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterBuilder.prototype, "characterValidation", void 0);
__decorate([
    Prop(Number)
], CharacterBuilder.prototype, "currentStep", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "classes", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "archetypes", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "equipment", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "powers", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "feats", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "features", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "backgrounds", void 0);
__decorate([
    Prop(Array)
], CharacterBuilder.prototype, "species", void 0);
__decorate([
    Prop(Boolean)
], CharacterBuilder.prototype, "isDirty", void 0);
CharacterBuilder = __decorate([
    Component({
        components: {
            CharacterBuilderViewSheet,
            CharacterBuilderSettings,
            CharacterBuilderSpecies,
            CharacterBuilderClasses,
            CharacterBuilderAbilityScores,
            CharacterBuilderDescription,
            CharacterBuilderEquipment
        }
    })
], CharacterBuilder);
export default CharacterBuilder;
